import "./style.css";
const Tile = ({ tile }) => {
    const { grow, media, mediaType, caption, link } = tile || {};

    return (
        <a href={link ?? ""} className={`Tile w-full h-full`} style={{ flexGrow: grow }}>
            {mediaType === "image" ? (
                <img
                    lazyload='true'
                    className='Media'
                    src={media}
                    alt={caption}
                    style={{ objectFit: "cover" }}
                />
            ) : (
                <video className='Media' src={media}></video>
            )}
            <div
                style={{ zIndex: 2 }}
                className='Caption text-secondary font-thin text-xs lg:text-lg flex flex-row items-center justify-center absolute w-full '
            >
                {caption && (
                    <div className='w-full text-center py-1 text-wrap'>
                        {caption}
                    </div>
                )}
            </div>
        </a>
    );
};

export default Tile;
